var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73145 15.1938C8.86895 15.2625 8.9377 15.2625 9.0752 15.2625C9.2127 15.2625 9.3502 15.2625 9.41895 15.1938L14.2314 12.3063C14.4377 12.1688 14.5752 11.9625 14.5752 11.6875C14.5752 11.4125 14.4377 11.2063 14.2314 11.0688L9.41895 8.18125C9.2127 8.04375 8.9377 8.04375 8.73145 8.18125C8.5252 8.31875 8.3877 8.525 8.3877 8.8V14.575C8.3877 14.85 8.5252 15.0563 8.73145 15.1938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.57502L12.7188 3.30002C13.0625 3.09377 13.1312 2.68127 12.925 2.33752C12.7187 1.99377 12.3062 1.92502 11.9625 2.13127L9.9 3.50627C9.7625 3.64377 9.625 3.85002 9.625 4.05627C9.625 4.26252 9.69375 4.46877 9.83125 4.60627L11.8937 6.66877C12.0312 6.80627 12.1687 6.87502 12.375 6.87502C12.5813 6.87502 12.7188 6.80627 12.8563 6.66877C13.1313 6.39377 13.1313 5.98127 12.8563 5.70627L12.0312 4.88127C15.3313 5.43127 17.875 8.25002 17.875 11.6875C17.875 15.4688 14.7812 18.5625 11 18.5625C7.21875 18.5625 4.125 15.4688 4.125 11.6875C4.125 9.35002 5.29375 7.21877 7.21875 5.91252C7.5625 5.70627 7.63125 5.29377 7.425 4.95002C7.21875 4.67502 6.80625 4.53752 6.53125 4.81252C4.125 6.32502 2.75 8.86877 2.75 11.6875C2.75 16.225 6.4625 19.9375 11 19.9375C15.5375 19.9375 19.25 16.225 19.25 11.6875C19.25 7.63127 16.2937 4.26252 12.375 3.57502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayBtn);
export default __webpack_public_path__ + "static/media/replay_btn.9a576329eb864b2103ac9c44d3e04236.svg";
export { ForwardRef as ReactComponent };